import { Typography } from '@mui/material';
import Colors from 'js/constants/colors';

const ComboBoxInfoText = ({ sx, text = 'Select an option or manually enter a value' }) => (
    <Typography
        variant="body2"
        sx={{
            color: Colors.BLACK_30_OPAQUE,
            marginBottom: '5px',
            ...sx,
        }}
    >
        {text}
    </Typography>
)

export default ComboBoxInfoText;
